import React from 'react';
import View from '../Designer/View';
import Button from '../Designer/Button';

export default class StickyOfferLink extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            sourceButtonText: null,
            sourceButtonElement: null,
            isVisible: this.isBlockVisible(),
        };
    }

    componentDidMount() {

        if (!this.state.sourceButtonElement) {

            const sourceOfferLink = document.querySelector('#company-head-apply');
            if (sourceOfferLink)
                this.setState({
                    sourceButtonText: sourceOfferLink.innerText,
                    sourceButtonElement: sourceOfferLink,
                });

            let timeoutId = null;
            window.addEventListener('scroll', () => {

                if (timeoutId == null)

                    this.setState({ isVisible: false });

                else

                    clearTimeout(timeoutId);


                timeoutId = setTimeout(() => {

                    this.setState({ isVisible: this.isBlockVisible() });
                    timeoutId = null;

                }, 500);
            });
        }
    }

    isBlockVisible() {

        return window.scrollY > (window.innerHeight / 2);
    }

    render() {

        if (!this.state.sourceButtonElement)
            return null;

        const classes = ['tablet:hidden desktop:hidden transition-opacity'];
        if (!this.state.isVisible)
            classes.push('hidden');

        return (
            <View className={ classes.join(' ') }>
                <View className='fixed-top w-full flex bg-white p-4 shadow-xl'>
                    <Button className='button w-full' onClick={ () => this.onOfferClick() }>
                        { this.state.sourceButtonText }
                    </Button>
                </View>
            </View>
        );
    }

    onOfferClick() {

        this.state.sourceButtonElement.click();
    }

}